// extracted by mini-css-extract-plugin
export default {"activationForm":"style_activationForm__E4f29","phoneInput":"style_phoneInput__U15ck","notification":"style_notification__-IiNL","btnsWrapper":"style_btnsWrapper__GPhQS"};